var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueGreenMarkerNavyOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-1.44 -1.44 38.88 38.88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#0e000c",
    strokeWidth: 5.544
  }, /*#__PURE__*/React.createElement("title", null, "map-marker"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    id: "Vivid.JS",
    strokeWidth: 1.044,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vivid-Icons",
    transform: "translate(-125.000000, -643.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(37.000000, 169.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map-marker",
    transform: "translate(78.000000, 468.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,0 C21.732,0 28,5.641 28,12.6 C28,23.963 14,36 14,36 C14,36 0,24.064 0,12.6 C0,5.641 6.268,0 14,0 Z",
    id: "Shape",
    fill: "#46b5c2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#0e007a",
    fillRule: "nonzero",
    cx: 14,
    cy: 14,
    r: 7
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "map-marker"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    id: "Vivid.JS",
    strokeWidth: 1.044,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vivid-Icons",
    transform: "translate(-125.000000, -643.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(37.000000, 169.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map-marker",
    transform: "translate(78.000000, 468.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,0 C21.732,0 28,5.641 28,12.6 C28,23.963 14,36 14,36 C14,36 0,24.064 0,12.6 C0,5.641 6.268,0 14,0 Z",
    id: "Shape",
    fill: "#46b5c2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#0e007a",
    fillRule: "nonzero",
    cx: 14,
    cy: 14,
    r: 7
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueGreenMarkerNavyOutline);
export default __webpack_public_path__ + "static/media/blue-green-marker-navy-outline.1a1cf3f92a3de064d3b44e0afb22caf7.svg";
export { ForwardRef as ReactComponent };